import { DefaultValue } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface FormItemWrapperProps {
  isHorizontal?: boolean
}

export const FormItemWrapper = styled.div<FormItemWrapperProps>`
  display: flex;
  flex: auto;

  label {
    display: none;
  }

  input,
  div {
    border-radius: 0;
  }

  input:focus,
  input:hover {
    position: relative;
    z-index: 1;
  }

  ${({ isHorizontal }) =>
    isHorizontal
      ? css`
          > div:not(:first-of-type) input {
            margin-left: -1px;
          }

          > div:first-of-type div {
            border-top-left-radius: ${DefaultValue.BorderRadius};
            border-bottom-left-radius: ${DefaultValue.BorderRadius};
          }

          > :last-child div,
          :last-child input {
            border-top-right-radius: ${DefaultValue.BorderRadius};
            border-bottom-right-radius: ${DefaultValue.BorderRadius};
          }
        `
      : css`
          input {
            margin-top: -1px;
          }

          > div {
            margin-bottom: 0;
          }

          > div:first-of-type div,
          div:first-of-type input {
            border-top-left-radius: ${DefaultValue.BorderRadius};
            border-top-right-radius: ${DefaultValue.BorderRadius};
          }

          > :last-child div,
          :last-child input {
            border-bottom-right-radius: ${DefaultValue.BorderRadius};
            border-bottom-left-radius: ${DefaultValue.BorderRadius};
          }
        `}
`
